import { useFlightContext } from "hooks/flight/useFlightContext";
import useFlightSearchParams from "hooks/flight/useFlightSearchParams";
import { Offcanvas, OffcanvasHeader, OffcanvasBody } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BiMinus, BiPlus } from "react-icons/bi";
import { FaCheck } from "react-icons/fa6";
import { GrClose } from "react-icons/gr";

const MobilePassengersDropDown = ({ isOpen, onHide }) => {
    const { t } = useTranslation();
    const { updateFlightSearchParams, updateTravelers } =
        useFlightSearchParams();
    const { flightSearchParams } = useFlightContext();
    return (
        <Offcanvas
            placement="bottom"
            show={isOpen}
            onHide={onHide}
            className="h-screen"
            tabIndex={-1}
            id="offcanvasSidebar"
        >
            <OffcanvasHeader className="offcanvas-header p-3 flex items-center justify-between border-b ">
                <div className="text-xl ">Passagers & Classe</div>
                <GrClose size={18} onClick={onHide} cursor={"pointer"} />
            </OffcanvasHeader>
            <OffcanvasBody className="offcanvas-body flex-column p-0 ">
                <div
                    className="traveller-calulate-persons p-4"
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <div className="passengers">
                        <h6>{t("passengers")}</h6>
                        <div className="passengers-types">
                            <div className="passengers-type">
                                <div className="text">
                                    <span className="count pcount">
                                        {flightSearchParams?.nrOfAdult}
                                    </span>
                                    <div className="type-label">
                                        <p className="text-lg  text-black">
                                            {t("adultsAndPlus")}
                                        </p>
                                    </div>
                                </div>
                                <div className="button-set flex gap-1">
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("ADT", "ADD")
                                        }
                                    >
                                        <BiPlus size={22} />
                                    </div>
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("ADT", "SUB ")
                                        }
                                    >
                                        <BiMinus size={22} />
                                    </div>
                                </div>
                            </div>
                            <div className="passengers-type">
                                <div className="text">
                                    <span className="count ccount">
                                        {flightSearchParams?.nrOfChild}
                                    </span>
                                    <div className="type-label">
                                        <p className="text-lg  text-black">
                                            {t("childrenTwoAndMinus")}
                                        </p>
                                    </div>
                                </div>
                                <div className="button-set flex gap-2">
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("CHD", "ADD")
                                        }
                                    >
                                        <BiPlus size={22} />
                                    </div>
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("CHD", "SUB ")
                                        }
                                    >
                                        <BiMinus size={22} />
                                    </div>
                                </div>
                            </div>
                            <div className="passengers-type">
                                <div className="text">
                                    <span className="count incount">
                                        {flightSearchParams?.nrOfInfant}
                                    </span>
                                    <div className="type-label">
                                        <p className="text-lg  text-black">
                                            {t("infantsAndMinus")}
                                        </p>
                                    </div>
                                </div>
                                <div className="button-set flex gap-1">
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("INF", "ADD")
                                        }
                                    >
                                        <BiPlus size={22} />
                                    </div>
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("INF", "SUB ")
                                        }
                                    >
                                        <BiMinus size={22} />
                                    </div>
                                </div>
                            </div>
                            <div className="passengers-type">
                                <div className="text">
                                    <span className="count">
                                        {flightSearchParams?.nrOfSenior}
                                    </span>
                                    <div className="type-label">
                                        <p className="text-lg  text-black">
                                            {t("seniorPassenger") || "3ème âge"}
                                        </p>
                                        <span className="text-paragraph-color text-sm">60+</span>
                                    </div>
                                </div>
                                <div className="button-set flex gap-1">
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("senior", "ADD")
                                        }
                                    >
                                        <BiPlus size={22} />
                                    </div>
                                    <div
                                        className=" size-8 cursor-pointer flex items-center justify-center border-2 border-main-color text-main-color"
                                        onClick={() =>
                                            updateTravelers("senior", "SUB ")
                                        }
                                    >
                                        <BiMinus size={22} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="cabin-selection">
                        <h6> {t("cabinClass")}</h6>
                        <div className="cabin-list">
                            <button
                                type="button"
                                className={`label-select-btn ${
                                    flightSearchParams?.cabinClass === "Y"
                                        ? "active"
                                        : ""
                                }`}
                                onClick={() => {
                                    updateFlightSearchParams("cabinClass", "Y");
                                }}
                            >
                                <span className="muiButton-label flex items-center justify-between w-full">
                                    <div className="">{t("economy")}</div>
                                    {flightSearchParams?.cabinClass === "Y" && (
                                        <FaCheck color="white" size={18} />
                                    )}
                                </span>
                            </button>
                            <button
                                type="button"
                                className={`label-select-btn flex items-center duration-150 ${
                                    flightSearchParams?.cabinClass === "C"
                                        ? "active"
                                        : ""
                                }`}
                                onClick={() => {
                                    updateFlightSearchParams("cabinClass", "C");
                                }}
                            >
                                <span className="muiButton-label flex items-center justify-between w-full">
                                    <div className="">{t("business")}</div>
                                    {flightSearchParams?.cabinClass === "C" && (
                                        <FaCheck color="white" size={18} />
                                    )}
                                </span>
                            </button>
                            <button
                                type="button"
                                className={`label-select-btn ${
                                    flightSearchParams?.cabinClass === "F"
                                        ? "active"
                                        : ""
                                }`}
                                onClick={() => {
                                    updateFlightSearchParams("cabinClass", "F");
                                }}
                            >
                                <span className="MuiButton-label flex items-center justify-between w-full ">
                                    <div className="">{t("firstClass")}</div>
                                    {flightSearchParams?.cabinClass === "F" && (
                                        <FaCheck color="white" size={18} />
                                    )}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default MobilePassengersDropDown;
